export default class formUnselectSiblingRadioInputs {
    constructor (element) {
        this.element = element
        this.element.addEventListener('click', this.handleClick.bind(this))
    }

    handleClick (e) {
        e.preventDefault()
        const checkedSiblingInputElements = this.getCheckedSiblingInputElements()
        checkedSiblingInputElements.forEach(input => this.uncheckInput(input))
    }

    getCheckedSiblingInputElements () {
        const parent = this.element.parentElement
        if (!parent) {
            return []
        }
        const siblings = Array.from(parent.querySelectorAll(':scope > input:checked'))
        return siblings.filter(child => child !== this.element)
    }

    uncheckInput (input) {
        input.removeAttribute('checked')
        input.checked = false
        this.triggerChangeEvent(input)
    }

    triggerChangeEvent (item) {
        const event = new Event('change')
        item.dispatchEvent(event)
    }
}
